import React from 'react';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';

import FieldTextArea from './FieldTextArea.jsx';
import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';

const fields = {
  mistakes: {
    label: 'Mistakes',
    description: 'What mistakes were made as a driver?',
    field: 'mistakes',
  },
  improvements: {
    label: 'Improvements',
    description: 'What improvements as a driver can be made?',
    field: 'improvements',
  },
  ratings: [
    {
      label: 'Self-Preparation',
      description: 'Your preparation for race: notes, film, shop time, etc.',
      field: 'selfPreparation',
      dropdownDescriptions: {
        1: 'Terrible',
        10: 'Exceptional',
      },
    },
    {
      label: 'Team-Preparation',
      description: 'Team\'s preparation for race: plan, tools, organization, etc.',
      field: 'teamPreparation',
      dropdownDescriptions: {
        1: 'Terrible',
        10: 'Exceptional',
      },
    },
    {
      label: 'Overall Vehicle Preparation',
      description: 'Overall vehicle preparation: adjustments, issues, etc.',
      field: 'carPreparation',
      dropdownDescriptions: {
        1: 'Terrible',
        10: 'Exceptional',
      },
    },
    {
      label: 'Team Emotional Support',
      description: 'How team was emotionally supportive: listening, attitude, positivity, etc.',
      field: 'emotionalSupport',
      dropdownDescriptions: {
        1: 'Terrible',
        10: 'Exceptional',
      },
    },
    {
      label: 'Overall Team Evaluation',
      description: null,
      field: 'overallEvaluation',
      dropdownDescriptions: {
        1: 'Terrible',
        10: 'Exceptional',
      },
    },
  ],
};

const overrideOptions = [
  { slug: 1, value: '1 - Poor' },
  { slug: 2, value: '2 - Below Average' },
  { slug: 3, value: '3 - Average' },
  { slug: 4, value: '4 - Above Average' },
  { slug: 5, value: '5 - Exceptional' },
];

export default function DirtReflection() {
  return (
    <div id="section-dirt-reflection">
      <h4 className="rating-type">Reflection</h4>
      <p className="subtext">All information given is confidential and will not be shared with any group outside of TRD.</p>

      <Row>
        {[fields.mistakes, fields.improvements].map((field, i) => (
          <Col xs={12} sm={6} key={`${i}.${field.field}`}>
            <h6 style={{ marginBottom: '5px' }}>
              {i + 1}) {field.label}

              <small>
                <br />({field.description})
              </small>
            </h6>
            <FieldTextArea
              field={field.field}
              placeholder="Describe"
            />
          </Col>
        ))}

        {fields.ratings.map((question, i) => (
          <Col xs={12} sm={6} key={question.field}>
            <FieldTextAreaWithRating
              label={`${(i + 3)}) ${question.label}`}
              description={(question.description) ? `${question.description}` : null}
              ratingField={`${question.field}.rating`}
              textAreaField={`${question.field}.feedback`}
              placeholder="Feedback"
              nonTrackRating={true}
              dropdownDescriptions={_.get(question, 'dropdownDescriptions')}
              overrideOptions={_.reverse(overrideOptions)}
              overrideDefaultValue={5}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
